import { Box, ContentBlock, Notice, Stack, Text } from 'braid-design-system';

import { FeaturePromoBlock } from 'src/components/FeaturePromoBlock/FeaturePromoBlock';
import Image5 from 'src/images/products/add-profile-to-database.png';
import Image3 from 'src/images/products/filter-by.png';
import Image4 from 'src/images/products/interaction-history.png';
import Image6 from 'src/images/products/profile-actions.png';
import Image2 from 'src/images/products/shared-candidates.png';
import Image7 from 'src/images/products/similar-candidates.png';
import Image1 from 'src/images/products/talent-search.png';

import { SolutionsWrapper } from '../../components/SolutionsWrapper';

export const TalentSearchConnect = () => (
  <SolutionsWrapper page="Talent Search Connect">
    <ContentBlock>
      <Stack align="center" space="none">
        <Notice tone="info">
          <Text>
            Talent Search Connect is coming soon. Check back regularly, or
            contact us for updates.
          </Text>
        </Notice>
      </Stack>
      <Box paddingX={['gutter', 'none']} paddingY={['none', 'xlarge']}>
        <Stack space={['xlarge', 'xxlarge']} dividers="regular">
          <FeaturePromoBlock
            title="Access SEEK Talent Search in-flow"
            text="Enjoy seamless access to SEEK's Talent Search from your own recruitment software."
            image={{
              url: Image1,
            }}
          />
          <FeaturePromoBlock
            title="See shared candidates"
            text="Easily identify candidates that appear across both SEEK's Talent Search and your own candidate database to help you leverage existing relationships."
            image={{
              url: Image2,
            }}
            reverse
          />
          <FeaturePromoBlock
            title="Profile Source filter"
            text="Leverage existing relationships or source new talent using filters between SEEK candidates and those in your database."
            image={{
              url: Image3,
            }}
          />
          <FeaturePromoBlock
            title="Combined interaction history"
            text="View interactions from your software and the candidate’s SEEK Profile to help you understand your relationship with each candidate."
            image={{
              url: Image4,
            }}
            reverse
          />
          <FeaturePromoBlock
            title="Import candidates with ease"
            text="Up-to-date candidate profile information and CVs easily imported into your recruitment software from SEEK’s Talent Search database."
            image={{
              url: Image5,
            }}
          />
          <FeaturePromoBlock
            title="One-click link to view candidate profiles"
            text="Seamlessly switch to your database's candidate profile from SEEK Talent Search for easier management."
            image={{
              url: Image6,
            }}
            reverse
          />
          <FeaturePromoBlock
            title="View similar profiles"
            text="Instantly see candidates in SEEK Talent Search that are similar to profiles in your database to build talent pools faster."
            image={{
              url: Image7,
              height: 'tall',
            }}
          />
        </Stack>
      </Box>
    </ContentBlock>
  </SolutionsWrapper>
);
